// number of days supported for insights statistics
export const STATISTICS_NUM_OF_DAYS = 10

// number of days supported for hostmap lookback
export const HOSTMAP_NUM_OF_DAYS = 7



// WEBPACK FOOTER //
// ./src/constants/statistics.constants.js